import Carousel from 'global/carousel.src';
import { YoutubeDialog } from 'global/simple-dialog.src';

[].forEach.call(document.querySelectorAll('.carousel'), (carousel) => {
    const c = new Carousel(carousel);
});

[].forEach.call(document.querySelectorAll('.youtube-trigger'), (btnElem) => {
    const dialogElem = document.getElementById(btnElem.getAttribute('data-dialog-id'));
    const youtubeDialog = new YoutubeDialog(dialogElem);

    btnElem.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        youtubeDialog.show();
    });
});
